import {useEffect, useState} from "react";
import { Navigate } from "react-router-dom";
import '../../styles/MaintenancePage.css'
import {useCookies} from "react-cookie";

export default function MaintenancePage() {

    const [cookies] = useCookies(["token"]);
    const [loading, setLoading] = useState(false);
    const [datas, setDatas] = useState([]);
    const token = cookies.token;


    function redirectToHome() {

    }

    useEffect(() => {

        const checkAccess = async () => {

            try {

                const res = await fetch(
                    "https://api.industriegaming.fr/api/script/request/getall",
                    {
                        headers: {
                            Authorization: `Bearer ${token}`
                        }
                    }
                );

                if (res.status === 503) {
                    const data = await res.json();
                    setDatas(data);
                    setLoading(true)
                }
                else {

                }

            } catch (err) {
                console.error(err);
            } finally {
                console.log("Vérification de l'accès terminée");
            }

        };

        checkAccess();

    }, [token]);

    console.log(datas)

    return (
        <main className="maintenance-page">

            {datas.maintenance_image ? (
                <img
                    src={datas.maintenance_image}
                    alt="Illustration de maintenance"
                    className="maintenance-image"
                />
            ) : (
                <img
                    src="https://media.tenor.com/qc0mo2Wd7XcAAAAM/dclfam-decentraland.gif"
                    alt="Youpiii"
                    className="maintenance-image"
                />
            )}

            <h1>
                {datas.maintenance_enabled ?
                    (<p>{datas.maintenance_title}</p>) :
                    (<p>Le site est de retour !</p>)
                }
            </h1>

            {datas.maintenance_enabled ?
                (<p>{datas.maintenance_message}</p>) :
                (<p>Clique <a href='/dashboard'>ici</a> pour retourné sur le dashboard.</p>)
            }

            {datas.maintenance_reopen_at && (
                <p>
                    Réouverture prévue :
                    {" "}
                    {new Date(
                        datas.maintenance_reopen_at
                    ).toLocaleString("fr-FR")}
                </p>
            )}

            {datas.maintenance_enabled ?
                (
                    <div className="maintenance-footer">
                        Merci de votre compréhension.
                    </div>
                ) : null}

        </main>
    );
}